import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'parsingData',
})
export class ParsingDataPipe implements PipeTransform {
    public transform(value: string, which: string, color?: boolean): string {
        if (!value) {
            return '';
        }
        switch (which) {
            case 'condition':
                return this.statusParsing(value, color);
            case 'institutionableType':
                return this.insTypeParsing(value, color);
            case 'accreditation':
                return this.accreditationParsing(value, color);
            case 'buildingCondition':
                return this.buildingConditionParsing(value, color);
            case 'unit':
                return this.equipmentUnit(value);
            default:
                return color ? 'secondary' : value;
        }
    }

    public statusParsing(value: string, color?: boolean) {
        switch (value.toLowerCase()) {
            case 'operational':
                return color ? 'info' : 'Beroperasi';
            case 'new':
                return color ? 'primary' : 'Lembaga Baru';
            case 'not_operational':
                return color ? 'secondary' : 'Tidak Beroperasi';
            default:
                return color ? 'secondary' : value;
        }
    }

    public insTypeParsing(value: string, color?: boolean) {
        switch (value.toLowerCase()) {
            case 'government':
                return color ? 'info' : 'Pemerintah';
            case 'private':
                return color ? 'warning' : 'Swasta';
            case 'industrial':
                return color ? 'success' : 'Industri';
            default:
                return color ? 'secondary' : value;
        }
    }

    public accreditationParsing(value: string, color?: boolean) {
        switch (value.toLowerCase()) {
            case 'accredited':
                return color ? 'success' : 'Terakreditasi';
            case 'not_accredited':
                return color ? 'secondary' : 'Belum Terakreditasi';
            default:
                return color ? 'secondary' : value;
        }
    }

    public buildingConditionParsing(value: string, color?: boolean) {
        switch (value.toLowerCase()) {
            case 'very_good':
                return color ? 'success' : 'Sangat Baik';
            case 'good':
                return color ? 'info' : 'Baik';
            case 'normal':
                return color ? 'warning' : 'Cukup Baik';
            case 'slightly_damaged':
                return color ? 'warning' : 'Rusak Ringan';
            case 'bad':
                return color ? 'danger' : 'Buruk';
            case 'empty':
                return color ? 'light' : '–';
            default:
                return color ? 'secondary' : value;
        }
    }

    public equipmentUnit(value: string) {
        switch (value.toLowerCase()) {
            case 'unit': return 'Unit';
            case 'set': return 'Set';
            case 'piece': return 'Buah';
            case 'roll': return 'Rol';
            case 'meter': return 'Meter';
            case 'pair': return 'Pasang';
            default: return value;
        }
    }
}



// WEBPACK FOOTER //
// ./src/shared/module/common/pipe/parsing-data.pipe.ts